export default __webpack_public_path__ + "static/media/policy15_2023.0beb3849.jpg";